import { createRouter, createWebHistory } from 'vue-router';
import { routes } from './routes';
import { useAuth } from '@/composables/auth';
import { useCurrentUser } from '@/composables/currentUser';
import { useFeatureFlags } from '@/composables/featureFlags';
import { useAppReady } from '@/composables/appReady';

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach(async (to, from, next) => {
    const { isAuthenticated } = useAuth();
    const { hasPermissions } = useCurrentUser();
    const { hasFeatureFlags } = useFeatureFlags();

    const { untilDataReady } = useAppReady();

    const {
        requiresAuth,
        requiresNotAuth,
        permissions,
        matchPermissionsStrategy,
        featureFlags,
        matchFeatureFlagsStrategy,
    } = to.meta;

    await untilDataReady();

    if (requiresAuth && !isAuthenticated.value) {
        next('/login');
        return;
    }

    if (requiresNotAuth && isAuthenticated.value) {
        next('/');
        return;
    }

    if (permissions) {
        if (!hasPermissions(permissions, matchPermissionsStrategy)) {
            next('/forbidden');
            return;
        }
    }

    if (featureFlags) {
        if (!hasFeatureFlags(featureFlags, matchFeatureFlagsStrategy)) {
            next({ name: '404' });
            return;
        }
    }

    next();
});

export default router;
